import React, { useEffect, useState } from 'react';
import { Box, Typography, List, ListItem, ListItemText, Divider } from '@mui/material';
import { getDecryptedAccessToken } from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';
import ApiServices from '../../../Utils/ApiServices/ApiServices';

const AllDietPlanQuestionnaire = () => {
  const accessToken = getDecryptedAccessToken();
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    const fetchQuestionnaire = async () => {
      try {
        const response = await ApiServices.get('/apis/default/api/dietplanquestionnaire', {
          Authorization: `Bearer ${accessToken}`,
        });
        const questionnaire = response?.data?.content?.questionnaire || [];
        setQuestions(questionnaire);
      } catch (error) {
        console.error('Failed to fetch questionnaire:', error);
      }
    };

    fetchQuestionnaire();
  }, [accessToken]);

  return (
    <Box sx={{ padding: 2 }}>
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Health & Nutrition Questionnaire
      </Typography>

      <List>
        {questions.map((q, index) => (
          <Box key={q.id} sx={{ marginBottom: 2 }}>
            <Typography variant="subtitle1" fontWeight="bold">
              Q{index + 1}: {q.question}
            </Typography>

            <Typography variant="body2" color="text.secondary">
              Type: {q.type.replace('_', ' ')}
            </Typography>

            {q.options?.length > 0 && (
              <Box sx={{ marginTop: 1 }}>
                <Typography variant="body2" fontWeight="medium">Options:</Typography>
                <ul style={{ margin: 0, paddingLeft: 20 }}>
                  {q.options.map((opt, idx) => (
                    <li key={idx}>
                      <Typography variant="body2">{opt}</Typography>
                    </li>
                  ))}
                </ul>
              </Box>
            )}

            <Divider sx={{ marginY: 2 }} />
          </Box>
        ))}
      </List>
    </Box>
  );
};

export default AllDietPlanQuestionnaire;
